import { Project, ProjectAPI } from '@brg/api';

import { useAPIMethod } from '../useAPIMethod';

export const useProject = (projectId: string, lang: string, time?: unknown, disabled?: boolean) => {
  return useAPIMethod<Project, any>(ProjectAPI.Get, { idProject: projectId }, lang, time, !projectId || disabled);
}

import { Project, ProjectAPI } from '@brg/api';

import { useAPIMethod } from '../useAPIMethod';

export const useProject = (projectId: string, lang: string, time?: unknown, disabled?: boolean) => {
  return useAPIMethod<Project, any>(ProjectAPI.Get, { idProject: projectId }, lang, time, !projectId || disabled);
}

